<div class="container h-100">
  <div class="d-flex align-items-center justify-content-center h-100">
    <div class="d-flex flex-column">
      <img class="mb-4" src="assets/images/flex-logo-color.svg" width="200" alt="Securly Flex"/>
      <button *ngIf="!environment.mobile" class="btn btn-primary my-2" (click)="goTo('mobile')" >{{ 'USE_MOBILE_APP' | translate }}</button>
      <button *ngIf="showUseWebBrowserButton" class="btn btn-secondary my-2" (click)="goTo('web')" >{{ 'USE_WEB_BROWSER' | translate }}</button>
    </div>
  </div>
</div>
